import { render, staticRenderFns } from "./jinglijihuo.vue?vue&type=template&id=35f23fa6&scoped=true&"
import script from "./jinglijihuo.vue?vue&type=script&lang=js&"
export * from "./jinglijihuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f23fa6",
  null
  
)

export default component.exports